import { FC } from 'react';
import { Select } from '@dynamika-shared/ui/Select/Select';
import {
  propertyOperatorOptions,
  taskStatusesOptions,
  taskTagType,
} from './conditionOptions';
import { Input } from '@dynamika-shared/ui/Input/Input';
import { selectProps, inputProps } from '../formProps';
import { Option } from '@utils/generateOptions';
import {
  TaskDefinitionTag,
  CollectionElementTypeStatuses,
  TaskStatuses,
  CollectionElementTypeResult,
} from '@dynamika-shared/types/pmTaskDefinitions';

type TaskConditionProps = {
  updateCondition: (fieldPath: string, value: unknown) => void;
  currentCondition: TaskDefinitionTag;
  tagOptions: Option[];
};

export const TaskCondition: FC<TaskConditionProps> = ({
  currentCondition,
  tagOptions,
  updateCondition,
}) => {
  const collectionElementType =
    currentCondition.collectionElementType as CollectionElementTypeStatuses;

  const onSelect = (status: TaskStatuses) => {
    updateCondition('collectionElementType.statuses', [
      ...collectionElementType.statuses,
      status,
    ]);
  };

  const onDeselect = (status: TaskStatuses) => {
    const updatedStatuses = collectionElementType.statuses.filter(
      s => s !== status
    );
    updateCondition('collectionElementType.statuses', updatedStatuses);
  };

  return (
    <>
      <Select
        {...selectProps}
        options={tagOptions}
        value={
          currentCondition.collectionElementType?.type !== '.All' &&
          currentCondition.collectionElementType?.id
        }
        onChange={id => updateCondition('collectionElementType.id', id)}
        label='Tag'
        placeholder='Select tag'
        autoDropdownWidth
      />
      {currentCondition.collectionElementType?.type !== '.All' &&
        currentCondition.collectionElementType?.id && (
          <Select
            {...selectProps}
            options={taskTagType}
            value={currentCondition.collectionElementType?.type}
            onChange={type => {
              const data =
                type === '.TagIdStatuses'
                  ? { type, statuses: [], id: collectionElementType.id }
                  : type === '.TagIdResultProperty'
                  ? {
                      type,
                      id: collectionElementType.id,
                      propertyOperator: '=',
                    }
                  : {
                      type,
                      id: collectionElementType.id,
                    };
              updateCondition('collectionElementType', data);
            }}
            label='Type tag'
            placeholder='Select type tag'
          />
        )}
      {currentCondition.collectionElementType?.type && (
        <>
          {currentCondition.collectionElementType?.type === '.TagIdStatuses' ? (
            <Select
              {...selectProps}
              mode='multiple'
              maxTagCount={1}
              options={taskStatusesOptions}
              value={currentCondition.collectionElementType?.statuses}
              onSelect={onSelect}
              onDeselect={onDeselect}
              label='Statuses'
              placeholder='Select statuses'
            />
          ) : (
            <Select
              {...selectProps}
              options={taskStatusesOptions}
              value={
                currentCondition.collectionElementType?.type !== '.All' &&
                currentCondition.collectionElementType?.status
              }
              onChange={status =>
                updateCondition('collectionElementType.status', status)
              }
              label='Status'
              placeholder='Select status'
            />
          )}
          {currentCondition.collectionElementType?.type ===
            '.TagIdResultProperty' && (
            <div className='flex'>
              <Input
                {...inputProps}
                className='-ml-[1.15rem] mr-1.5 w-[206px]'
                label='Result Path'
                placeholder='Path'
                value={currentCondition.collectionElementType?.propertyPath}
                onChange={e =>
                  updateCondition(
                    'collectionElementType.propertyPath',
                    e.target.value
                  )
                }
              />
              <Select
                {...selectProps}
                className='mr-1.5 w-[80px]'
                options={propertyOperatorOptions}
                value={
                  (currentCondition.collectionElementType as CollectionElementTypeResult)
                    ?.propertyOperator || '='
                }
                onChange={value =>
                  updateCondition('collectionElementType.propertyOperator', value)
                }
                label='Operator'
                placeholder='='
              />
              <Input
                {...inputProps}
                label='Result Value'
                placeholder='Value'
                value={currentCondition.collectionElementType?.propertyValue}
                onChange={e =>
                  updateCondition(
                    'collectionElementType.propertyValue',
                    e.target.value
                  )
                }
              />
            </div>
          )}
        </>
      )}
    </>
  );
};
